<template>
  <div>
    <color-picker v-model="colorPickerDialog" @updateColor="app.color = $event" :color="app.color"></color-picker>
    <v-row v-if="loadingApps">
      <v-col cols="12">
        <app-loading :message="$t('general.loadingApplication')"/>
      </v-col>
    </v-row>

    <v-row v-else>
      <!--<v-col cols="12">
        <v-row class="py-2 px-4" justify="space-between"  >
          <h2 style="display: inline;" id="title" class="hidden-xs-only">{{selectedApp.app_name}}</h2> <v-spacer></v-spacer>
          <v-chip @mouseover="displayCopyKeyBtn = true"
                  @mouseleave="displayCopyKeyBtn = false"
                  color="primary"
                  class="white&#45;&#45;text animate">
                  API Key: <span class="api-key">{{selectedApp.client_key}}</span>
                  <transition name="fade">
                    <v-btn icon dark @click="copyApiKey" v-if="displayCopyKeyBtn">
                        <v-icon>file_copy</v-icon>
                    </v-btn>
                  </transition>
          </v-chip>
        </v-row>
      </v-col>-->

      <v-col cols="12">
        <v-card class="kbWhite">
          <v-card-title>
              <v-row>
                  <v-col cols="12" class="d-flex justify-space-between mx-2">
                      <h4 class="font-weight-medium kbDarkBlueText--text">{{ selectedApp.app_name }}</h4>
                      <v-spacer></v-spacer>
                      <v-btn @mouseover="displayCopyKeyBtn = true"
                              @mouseleave="displayCopyKeyBtn = false"
                              @click="copyApiKey"
                              color="kbPurple"
                              dark
                              class="d-inline-block mr-3">
                          API Key: <span class="px-2">{{selectedApp.client_key}}</span>
                          <transition name="fade">
                              <v-btn icon
                                     dark
                                     v-if="displayCopyKeyBtn">
                                  <v-icon>file_copy</v-icon>
                              </v-btn>
                          </transition>
                      </v-btn>
                  </v-col>
              </v-row>
          </v-card-title>
          <v-card-text>
            <v-col cols="12">
                <v-text-field color="kbDarkBlueText" v-model="app.appName" :label="$t('general.name')"></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field color="kbDarkBlueText" v-model="app.baseUrl" :label="$t('general.baseUrl')"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field color="kbDarkBlueText" v-model="app.redirectUrl" :label="$t('general.redirectionUrl')"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field color="kbDarkBlueText" v-model="app.email" :label="$t('general.email')"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field color="kbDarkBlueText" v-model="app.prefix" :label="$t('general.prefix')" maxlength="3"></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-row align="center" justify="center">
                <v-avatar :color="app.color || $vuetify.theme.primary" size="50"></v-avatar>

                <v-btn color="kbDarkBlueText" text @click="colorPickerDialog = true">{{$t('general.pickAApplicationColor')}}</v-btn>
              </v-row>
            </v-col>
          </v-card-text>

          <v-card-actions class="kbLightBlue">
            <v-btn block text dark @click="submit" :loading="updatingApp">{{$t('general.saveChanges')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12">
        <ExtradataManagement/>
      </v-col>

      <v-col cols="12">
        <TypeOfTasksManagement/>
      </v-col>

      <v-col cols="12">
        <EpaycoData></EpaycoData>
      </v-col>
      <v-col cols="12">
        <EmailVerifyData></EmailVerifyData>
      </v-col>
<!--      <v-col cols="12">-->
<!--        <CalendarAuth></CalendarAuth>-->
<!--      </v-col>-->
      <v-col cols="12">
        <MicroSitesConfig></MicroSitesConfig>
      </v-col>
      <v-col cols="12">
        <Credentials></Credentials>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AppLoading from '@/components/widgets/Loading.vue'
import ColorPicker from '@/components/dialogs/ColorPicker.vue'
import EpaycoData from '@/pages/App/AppsDetails/EpaycoData.vue'
import EmailVerifyData from '@/pages/App/AppsDetails/EmailVerifyData.vue'
import ExtradataManagement from '@/pages/App/AppsDetails/ExtradataManagement.vue'
import MicroSitesConfig from '@/pages/App/AppsDetails/MicroSitesConfig.vue'
import Credentials from '@/pages/App/AppsDetails/Credentials.vue'
import notifications from '@/libs/notifications'
import TypeOfTasksManagement from '@/pages/App/AppsDetails/TypeOfTasksManagement.vue'

export default {
  created () {
    const companyId = this.$route.params.companyid
    const appId = this.$route.params.appid
    this.$store.dispatch('getApp', { companyId, appId, getStatistics: false })
    this.$store.dispatch('getProviders')
  },
  components: { AppLoading, ColorPicker, EpaycoData, EmailVerifyData, ExtradataManagement, MicroSitesConfig, Credentials, TypeOfTasksManagement },
  computed: {
    ...mapState({
      loadingApps: state => state.apps.loadingApps,
      selectedApp: state => state.apps.selectedApp,
      selectedCompany: state => state.companies.selectedCompany
    })
  },
  data () {
    return {
      app: {
        appName: '',
        baseUrl: '',
        color: '',
        email: '',
        mandrillKey: '',
        prefix: '',
        redirectUrl: ''
      },
      colorPickerDialog: false,
      displayCopyKeyBtn: false,
      updatingApp: false
    }
  },
  methods: {
    submit () {
      this.updatingApp = true
      const companyId = this.$route.params.companyid
      const appId = this.$route.params.appid
      const data = this.app
      this.$store.dispatch('updateApp', { companyId, appId, data }).then(() => {
        this.updatingApp = false
        notifications.success(this.$t('general.applicationSuccessfullyUpdated'))
      }).catch(error => {
        this.updatingApp = false
        notifications.error(error.message)
      })
    },
    copyApiKey () {
      navigator.clipboard.writeText(this.selectedApp.client_key).then(() => {
        notifications.success(this.$t('general.apiKeyCopied'))
      }).catch(() => {
        notifications.error(this.$t('general.apiKeyCopyError'))
      })
    },
    showUsers () {
      this.$router.push(`/apps/${this.selectedApp.UUID}/users`)
    }
  },
  watch: {
    selectedApp (value) {
      if (value.UUID) {
        this.app.appName = value.app_name
        this.app.baseUrl = value.baseUrl
        this.app.color = value.color
        this.app.email = value.email
        this.app.mandrillKey = value.mandrillKey
        this.app.prefix = value.prefix
        this.app.redirectUrl = value.redirectUrl
      }
    }
  }
}
</script>
